import { z } from "zod";
import { createRouter, query } from "react-safe-query";

const BASE_URL = "https://api.v3.invintusmedia.com";

interface Keyword {
  keyword: string;
  keywordID: string;
}

const getKeywordsPayloadSchema = z.object({
  clientID: z.string(),
});

export const keywordRouter = createRouter({
  getKeywords: query(async (input: z.infer<typeof getKeywordsPayloadSchema>) => {
    const { clientID } = input;

    const response = await fetch(`${BASE_URL}/V2/Console/getKeywordsNonPage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "console",
        "wsc-api-key": "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU",
      },
      body: JSON.stringify({ clientID }),
    });

    const json = await response.json();

    if (!response.ok) {
      throw new Error(json.message || "Failed to fetch keywords");
    }

    return json.data.clientKeywords as Keyword[];
  }),
});
